import { t } from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { envSetting } from '../constants/envSetting';
import { avatarImage, mediaAvatar } from '../constants/files';
import { fieldAttribute } from '../helpers/shared';
import { setMessage } from '../redux/actions/message';
import { saveUserImage } from '../redux/actions/files';
import { USER_SET_LOCAR_USER_AVATAR_IMG } from '../redux/types/user';

/**
 * Hook to avatar
 * @returns
 */
export const useAvatar = () => {
  const dispatch = useDispatch();
  const { userIdBifrost, srcAvatarImage, localSrcAvatarImage} = useSelector(state => state.user);
  const avatarSize = Math.round(parseInt(
    envSetting.avatarSize) / Math.pow(1024, 2), 2);
  const typeFiles = mediaAvatar.split(',');

  const onChange = ({ target: { files: comingFiles } }) => {
    if (comingFiles) {
      const [file] = comingFiles;
      const [currentFile] = Array.prototype.slice.call(comingFiles);

      if (file?.size > envSetting.avatarSize) {
        return dispatch(setMessage(t("files.errors.maxFileSize",
          { size: avatarSize }), 'error'));
      } else if (!typeFiles.includes(file.type)) {
        return dispatch(setMessage(
          t("files.errors.typeFileNotAllowed"), 'error'));
      }
      if (currentFile?.name) {
        const formMedia = new FormData();
        const imageChange = fieldAttribute('data-image', 'image-avatar');
        const newSrc = URL.createObjectURL(file);
        imageChange.src = newSrc;
        
        /* Local storage using file reader */
        const reader = new FileReader()

        reader.onload = (e) => {
          const base64String = e.target.result;
          console.log('?')
          dispatch({
            type: USER_SET_LOCAR_USER_AVATAR_IMG,
            payload: base64String
          })
        } 

        reader.readAsDataURL(file);

        formMedia.append(avatarImage, currentFile, currentFile.name);
        dispatch(saveUserImage(userIdBifrost, formMedia, true, false));
      }
    }
  };

  return { srcAvatarImage, avatarSize, onChange, localSrcAvatarImage };
};